import {getMethod} from '@/api'

export const get = async request => await getMethod('/api/partialSearchStatus', request)
